import getDownloadCSS from '../../../common/utils/getCss'
import { useEffect, useState } from 'react'
import {
  getEnvironment,
  getCWPEnvironmentForURL,
  APIENDPOINT,
} from '../../shared/utils/common-utils'
import convert from '../../../services/htmlToPdf'
import ExcelJS from 'exceljs'
import axios from 'axios'

export function clearLocalStorage() {
  localStorage.removeItem(`accumulation`)
  localStorage.removeItem(`distribution`)
  localStorage.removeItem(`SocialSecurity`)
  localStorage.removeItem(`TaxControlTriangle`)
  localStorage.removeItem(`WithdrawalRateSlider`)
  localStorage.removeItem(`BucketStrategy`)
}

export const getRigGlobal = async () => {
  const env = getCWPEnvironmentForURL(window.location.href)
  const rigGlobalUrl = `${APIENDPOINT(env).base}halapi/resourcebundles/ampmicrosites.rigglobal`
  try {
    const response = await fetch(rigGlobalUrl)
    const data = await response.json()
    return data
  } catch (error) {
    return null
  }
}
const getOriginUrl = () => {
  return getEnvironment() === 'local' ? 'https://www.qa.ameriprise.com' : window.location.origin
}

function routePath(match, before, path, after) {
  let result = match

  if (path.charAt(0) === '/') {
    const origin = getOriginUrl()
    result = before + origin + path + after
    // edge case with css font-face declaration
  } else if (path.startsWith("'/")) {
    const origin = getOriginUrl()
    result = `${before}${path.substring(0, 1)}${origin}${path.substring(1)}${after}`
  }
  return result
}

function routePaths(html) {
  return html
    .replace(/(src=")([^"]+)(")/g, routePath)
    .replace(/(href=")([^"]+)(")/g, routePath)
    .replace(/(url\(")([^")]+)(")/g, routePath)
    .replace(/(url\()([^)]+)(\))/g, routePath)
}

export async function getDownloadHtml(body) {
  const tags = document.getElementsByTagName('link')
  const cssFiles = []
  for (const currTag of tags) {
    const currentHref = currTag.href
    if (currentHref.includes('.css')) {
      cssFiles.push(await getDownloadCSS(currentHref))
    }
  }
  const html = `
    <html>
      <head>
        <meta charset="utf-8">
        <title>Retirement Income Guide</title>
        <style>${cssFiles.join('')}</style>
        <style>
        /* Override a few adel stylings which don't display as desired in pdf view */
        /* TODO:  Some of these will become redundant in a future ADEL release.  Delete if no longer needed */
        .page-break { page-break-after: always; }
        .u-adel-reset .Content ol, .u-adel-reset .Content ul { list-style-type: disc; }
        .u-adel-reset .Icon--after::after { visibility: hidden; }
        </style>
      </head>
      <body class="u-adel-reset amp-scope rig-scope">
        ${body}
      </body>
    </html>
    `
  return routePaths(html)
}

export default async function download(body, id) {
  const html = await getDownloadHtml(body)
  return convert(html, id)
}
export const getPageContent = async url => {
  try {
    const htmlText = await getDownloadCSS(url)
    const parser = new DOMParser(htmlText)
    const doc = parser.parseFromString(htmlText, 'text/html')
    return doc
  } catch (error) {
    return null
  }
}

export async function downloadPDFRIG(id, onCallback) {
  const element = document.getElementById('main-content')
  element.id = 'download-result'
  element.classList.add(id)
  const body = element.outerHTML || ''
  await download(body, id)
  element.classList.remove(id)
  element.id = 'main-content'
  onCallback(false)
}

export async function downloadAllPDF(id, onCallback) {
  try {
    const rigGlobal = await getRigGlobal()
    if (rigGlobal && rigGlobal.bundles && rigGlobal.bundles.default) {
      const rigUrl = `${getOriginUrl()}${rigGlobal.bundles.default['rig-url']}`
      const printAll = rigGlobal.bundles.default['print-all']
      const pages = printAll ? printAll.split(',') : []
      let urlsContents = ''
      for (const page of pages) {
        const pageUrl = `${rigUrl}/${page}`
        if (pageUrl) {
          const doc = await getPageContent(pageUrl)
          if (doc) {
            const mainContentDiv = doc.getElementById('main-content')
            mainContentDiv.id = 'download-result'
            mainContentDiv.classList.add(page)
            mainContentDiv.classList.add('download-all')
            if (mainContentDiv) {
              urlsContents += mainContentDiv.outerHTML
            }
          }
        }
      }
      if (urlsContents) {
        const downloadResultDiv = document.createElement('div')
        downloadResultDiv.id = 'all-pages-wrapper'
        downloadResultDiv.innerHTML = urlsContents
        document.body.appendChild(downloadResultDiv)
        setTimeout(async () => {
          const element = document.getElementById('all-pages-wrapper')
          const body = element.outerHTML || ''
          await download(body, id)
          document.body.removeChild(downloadResultDiv)
          onCallback(false)
        }, 3000)
      } else {
        onCallback(false)
      }
    } else {
      onCallback(false)
    }
  } catch (error) {
    onCallback(false)
  }
}

/* Get dropdown values fetched from excel*/
export const getDropdownData = async (url, idPrefix) => {
  try {
    const response = await fetch(url)
    const status = response.status
    if (status < 200 || status > 299) {
      throw Error('Error response: ' + status)
    }

    const readBuffer = await response.arrayBuffer()
    const workbook = await new ExcelJS.Workbook().xlsx.load(readBuffer)
    //Parsing sheets data
    const worksheet = workbook.getWorksheet(idPrefix)
    const contributionRateValues = worksheet.getColumn(1).values.slice(2)
    const contributionRateDefaultValue = worksheet.getColumn(2).values.slice(2)
    const interestAdjustmentRateValues = worksheet.getColumn(3).values.slice(2)
    const interestAdjustmentDefaultValue = worksheet.getColumn(4).values.slice(2)
    return {
      contributionRateDropdownValues: contributionRateValues,
      contributionRate: contributionRateDefaultValue,
      interestAdjustmentRateDropdownValues: interestAdjustmentRateValues,
      interestAdjustmentRate: interestAdjustmentDefaultValue,
    }
  } catch (e) {
    console.error('Error while fetching dropdown values', e)
    return {}
  }
}

export const adjustAdvisorData = data => {
  const DACData = {
    type: 'advisor',
    email: data.email,
    phone: data.phonenumber,
    name: data.displayname,
    image: data.profilesmallimage || data.profilelargeimage,
    designations: data.professionaldesignations,
    title: data.proffessionaltitle,
    urls: {
      referme: data.referMeUrl,
      site: data.siteUrl,
    },
    social: {
      linkedin: data.linkedInUrl,
    },
  }

  return DACData
}

export const useAdvisorInfo = () => {
  const [advisorData, setAdvisorData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      const query = new URLSearchParams(window.location.search)
      const advisorIdParam = query.get('advisorid')

      const env = getCWPEnvironmentForURL(window.location.href)
      const advisorInfoUrl = `${APIENDPOINT(env).advisor}GetAdvisorById?advisorId=${advisorIdParam}`

      try {
        let results

        if (!localStorage.getItem('results')) {
          const response = await axios.get(advisorInfoUrl)
          results = response.data.result
          localStorage.setItem('results', JSON.stringify(results))
        } else {
          results = JSON.parse(localStorage.getItem('results'))
        }

        const adjusted = adjustAdvisorData(results)
        setAdvisorData(adjusted)
      } catch (err) {
        console.error(err)
        setError(err)
      }
    }

    fetchData()
  }, [])

  return { advisorData, error }
}
